export default __webpack_public_path__ + "static/media/has-on-site-disabled.ef9fbd2a.svg";